export const navData = [
  {
    url: "https://static.vecteezy.com/system/resources/thumbnails/048/559/726/small/splashing-milk-into-glass-against-transparent-background-png.png",
    text: "Butter Milk",
    link: "product/product2",
  },
  {
    url: "https://static.vecteezy.com/system/resources/thumbnails/044/013/356/small_2x/premium-ghee-packaging-on-transparent-background-png.png",
    text: "Ghee",
    link: "product/product4",
  },
  {
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1688703537/MilkHouse/Navbar_data/Butter_xpdn8n.png",
    text: "Butter",
    link: "product/product6",
  },
  {
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1688703545/MilkHouse/Navbar_data/Milk_dra20z.png",
    text: "A2 Milk",
    link: "product/product1",
  },
  {
    url: "https://pngimg.com/d/yogurt_PNG15206.png",
    text: "Yogurt",
    link: "product/product5",
  },
  {
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1688705486/MilkHouse/Navbar_data/png-transparent-milk-malai-cream-paneer-ghee-milk-food-cheese-cream-cheese-thumbnail-removebg-preview_opkamh.png",
    text: "Paneer",
    link: "product/product7",
  },
];

export const bannerData = [
  {
    id: 1,
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1689220091/MilkHouse/BannerData/banner1_hqtug9.jpg",
  },
  {
    id: 2,
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1689220084/MilkHouse/BannerData/Banner2_tpoimr.jpg",
  },
  {
    id: 3,
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/c_fit,h_280/v1689220122/MilkHouse/BannerData/Screenshot_2023-07-13_091452_z1q6f1.png",
  },
  {
    id: 4,
    url: "https://res.cloudinary.com/dx0dgujbj/image/upload/v1689220119/MilkHouse/BannerData/Screenshot_2023-07-13_091238_xyhkkc.png",
  },
];
